import BaseModelFactory from './base.factory'
import RoyalRingRecipientService from './../services/RoyalRingRecipient.service'
import RoyalRingRecipient from './../models/royal-ring-recipient.model'

class RoyalRingRecipientFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: RoyalRingRecipientService, Model: RoyalRingRecipient }
    )

  static findAll = async () =>
    await this._findAllBy({}, { Service: RoyalRingRecipientService, Model: RoyalRingRecipient })

  static findById = async id =>
    await this._findBy({ id: id }, { Service: RoyalRingRecipientService, Model: RoyalRingRecipient })

  static findAllByUserId = async userId =>
    await this._findAllBy({ user_id: userId }, { Service: RoyalRingRecipientService, Model: RoyalRingRecipient })

  static findAllByRingType = async ringType =>
    await this._findAllBy({ ring_type: ringType }, { Service: RoyalRingRecipientService, Model: RoyalRingRecipient })

  static create = payload =>
    this._create(payload, {
      Service: RoyalRingRecipientService,
      Model: RoyalRingRecipient,
    })
}

export default RoyalRingRecipientFactory
